import React from 'react';
import PropTypes from 'prop-types';
import {getOptImage} from 'epic-ue-shared';

export default class Block extends React.Component {
    static propTypes = {
        block: PropTypes.object,
        useNarrowImage: PropTypes.bool
    };

    render() {
        const block = this.props.block || {};
        const useNarrowImage = this.props.useNarrowImage || false;
        const img = getOptImage({
            url: useNarrowImage ? block.narrowImage : block.image,
            width: 600
        });
        return (
            <div className={`block text-center ${useNarrowImage ? '' : 'narrow-block'}`}>
                <a href={block.url} target="_blank" rel="noopener noreferrer">
                    <img alt={block.title} src={img} />
                </a>
                <h4>{block.title}</h4>
            </div>
        );
    }
}
